import { baseUrl } from '@/consts/route';

import AppApi from './app-api';

export const getNaverSearch = async (query: string) => {
  const appApi = new AppApi(baseUrl);
  const res = await appApi.INSTANCE.get(`/naver-apis/search?query=${query}`);

  return res.data as NaverSearchResponse;
};

export const requestNaverPlaceId = async ({
  shop_address,
  shop_name,
}: RequestNaverPlaceIdDto): Promise<{ place_id: string }> => {
  const appApi = new AppApi(baseUrl);
  const res = await appApi.INSTANCE.post(`/naver-apis/place-id`, {
    shop_address,
    shop_name,
  });

  return res.data as { place_id: string };
};

export type NaverSearchItem = {
  title: string;
  link?: string;
  category: string;
  description?: string;
  telephone?: string;
  address: string;
  roadAddress: string;
  mapx?: string;
  mapy?: string;
};

export type NaverSearchResponse = {
  lastBuildDate: string;
  total: number;
  start: number;
  display: number;
  items: NaverSearchItem[];
};

export type RequestNaverPlaceIdDto = {
  shop_address: string;
  shop_name: string;
};
